module.exports = __webpack_public_path__ + "static/img/6.ff726de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/6.jpg
// module id = 4YnB
// module chunks = 0